export const getNumbersAfterAboutSite = (url: string) => {
  if (typeof window !== "undefined" && window.location.href.includes("aboutsitesecret")) {
    const match = url.match(/\/aboutsitesecret\/(\d+)/);
    if (match) {
      return match[1];
    } else {
      return "";
    }
  } else {
    const match = url.match(/\/aboutsite\/(\d+)/);
    if (match) {
      return match[1];
    } else {
      return "";
    }
  }
};
